<template>
	<div>
		<!-- 回款信息 productinfor -->
		<div class="btn_box Flexalign">
			<div class="customBtn FlexRow" style="width: 85px;" @click="addtinfor">
				<i class="el-icon-plus"></i>
				添加  
			</div>
			<div class="customBtn FlexRow style2" 
			@click="batchdele"
			:class="{'isdisabled': check_list.length < 1}">
				删除
			</div>
			<div class="customBtn FlexRow"  @click="exportres" v-show="0">
				输出
			</div>
		</div>
		
		<!-- 表格区域 -->
		<div class="table_box style1" v-loading="table_loading">

			<el-table ref="multipleTable" :header-cell-style="cellstyle" :row-style="rowstyle" style="width: 99%;margin: 0 auto;"
				:data="tablelist" @selection-change="handleSelectionChange">
				<!-- 表格内容 -->
				<el-table-column align="center" type="selection" fixed width="50"></el-table-column>
				<!--  -->
				<el-table-column show-overflow-tooltip :width="item.width" :align="item.align" :prop="item.prop"
					:label="item.name" v-for="(item, index) in tableColumn">
					<!-- 选择回款 -->
					<template v-slot="scope" v-if="index == 0">
						<el-select @change="SelectChange($event, scope.$index)"   v-model="scope.row.return_id" v-loadMore="loadMore" clearable
							filterable placeholder="选择回款">
							<el-option v-for="item in productlist" :key="item.return_id" :label="item.hk_name"
								:value="item.return_id">
							</el-option>
						</el-select>
					</template>
					<!-- 操作 -->
					<template v-slot="scope" v-else-if="index == 2">
						<span class="delspan" @click="deledatas(scope.$index)">
							删除
						</span>
					</template>
				
				</el-table-column>
				<!--  -->
			</el-table>

			<div class="amount_box FlexBetween" v-show="tablelist.length">
				<div class="amount_item" >
					合计
				</div>
				<div class="amount_item">
					订单金额：￥{{order_price}}
				</div>
				<div class="amount_item">
					已收总金额：￥{{amount_received}}
				</div>
				<div class="amount_item">
					未收金额：￥{{amount_not_received}}
				</div>
			</div>
		</div>
		<!--  -->

	

	</div>
</template>

<script>
	// 表格
	import tabcontainer from "@/components/tabledata/tabcontainer.vue";
	import {

		handlereq,
		retujudpower,
		retupower,
		alertMess,
		retfieldPower,
		fn_fielddisabled,
		fnCustomPage,
		exportExcel,

		formatCurrency,
		
	} from 'network/kh_public'
	import {
		hkl_list_return,
		hkl_details_return,
	} from 'network/hk_operset'
	export default {
		name: 'collectioninfor',
		props: {
			flag: {
				type: Boolean,
				default: false,
			},
			returnid: {
				type: String,
				default: '',
			},
			
		},
		components: {
			tabcontainer,
		},
		computed: {
			amount_received() {
				let res = 0
				for(let item of this.tablelist ) {
					if(item.money) {
						let n = item.money * 1
						res += n
					}
				}
				return res
			},
		},
		data() {
			return {
				
				order_price: '0.00',
				// amount_received:'0.00',
				amount_not_received:'0.00',
				
				current_id: 1,
				
				// 回款列表
				productlist: [],
				selectobj: {
					pagesize: 50,
					page: 1,
					last_page: 0,
				},
				// 
				nset_show: false,
				// 列表 ------------------
				cellstyle: {
					background: 'rgb(249,249,249)',
				},
				rowstyle: {
					height: '60px',
				},
				table_loading: false, // 加载中
				// 列表数据
				tablelist: [], 
				check_list: [], // 多选
				// 表格 表头
				tableColumn: [{
						id: 1,
						prop: 'return_id',
						name: '回款编码',
						width: 600,
					},
					{
						id: 2,
						prop: 'money', 
						name: '已收金额(￥)',
						width: 440,
					},
					{
						align: 'center',
						name: '操作',
					},
					
				],
				// ------------------
			}
		},
		methods: {
			fncleartable(){
				if(this.$refs.multipleTable) {
					this.$refs.multipleTable.clearSelection()
				}
			},
			gnmentcompa(e){
				this.order_price = e.order_price || '0.00';
				// this.amount_received = e.amount_received || '0.00';
				this.amount_not_received = e.amount_not_received || '0.00';
			},
			satisfyComputed(){
				let flag = this.tablelist.every(v=>v.return_id)
				if(flag) {
					let resArr = []
					for(let item of this.tablelist) {
						resArr.push(item.return_id)
					}
					let data = {
						return_id: resArr.join(','),
					}
					this.$emit('satisfy', data)
				}
			},
			// 输出结果
			exportres(){
				
				if(this.tablelist.length) {
					
					let flag = this.tablelist.every(v=>v.return_id)
					if(!flag) {
						alertMess('请选择回款','error')
						this.$emit('update:flag', false)
					}
					else {
						let resArr = []
						for(let item of this.tablelist) {
							resArr.push(item.return_id)
						}
						let data = {
							res: resArr.join(','),
						}
						this.$emit('fnexport', data)
						this.$emit('update:flag', true)
					}
				}
			},
			// 删除一行
			deledatas(index){
				this.tablelist.splice(index, 1)
				this.satisfyComputed()
				this.fncleartable()
			},
			// 批量删除 
			batchdele(){
				if (this.check_list.length) {
					for(let item of this.check_list) {
						let index = this.tablelist.findIndex(v=>v.id == item.id)
						if(index != -1 && this.tablelist[index]) {
							this.tablelist.splice(index, 1)
						}
					}
				}
				this.satisfyComputed()
				this.fncleartable()
			},
			// 新增回款信息 
			addtinfor() {
				this.current_id += 1
				let newEle = {
					return_id: '',
					money: '',
					id: this.current_id,
				}
				this.tablelist.push(newEle)
			},
			
			// 勾选表格
			handleSelectionChange(val) {
				this.check_list = val
			},
			
			// 检测选择回款是否有相同 
			SelectChange(e, index) {
				
				
				if (e) {
					let arr = this.tablelist.filter(v => v.return_id == e)
					if (arr.length == 2) { 
						alertMess('已有相同回款', 'warning')
					}
					let index1 = this.productlist.findIndex(v=>v.return_id == e)
					if(index1 != -1 && this.productlist[index1]) {
						let obj = this.productlist[index1]
						this.fn_getDelait(e, index)
					}
				}
				else {
					this.tablelist[index].money = 0
				}
				
				this.satisfyComputed()
			},
			// 获取回款 详情
			fn_getDelait(return_id, index) {
				hkl_details_return(return_id).then(res => {
					if (handlereq(res)) {
						let obj = res.result
						if (obj.return_info && typeof(obj.return_info) === 'string') {
							let val = JSON.parse(obj.return_info)
							let index2 = val.findIndex(v => v.field_sign == '回款金额')
							if (index2 != -1 && val[index2]) {
								let content = val[index2].content * 1
								this.tablelist[index].money = content || 0
							}
						}
						
					}
				})
			},
			noRepeat(arr){
			    let newArr = []
				
				var obj = {};
				newArr = arr.reduce(function(item, next) {
				       obj[next.return_id] ? '' : obj[next.return_id] = true && item.push(next);
				       return item;
				}, []);
				return newArr
			},
			//  获取回款列表
			getSelectList(return_id, flag) {
				let data = {
					pagesize: this.selectobj.pagesize,
					page: this.selectobj.page,
					sort_type: 1,
					is_recycle: 0,
				}
				if(return_id) {
					data.return_id = return_id
				}
				// 
				hkl_list_return(data).then(res => {
					if (handlereq(res)) {
						let obj = res.result.data
						if (obj && obj.length) {
							if(return_id && flag) {
								console.log(flag,'flag')
								this.setdetailList(obj)
								this.getSelectList() 
							}
							for (let item of obj) {
								item.hk_name = `${item.hk_code || ''}-${item.customer_name || ''}`
								this.productlist.push(item)
							}
							this.productlist = this.noRepeat(this.productlist)
							this.selectobj.last_page = res.result.last_page
						}
					}
				})
			},
			setdetailList(list){
				for(let item of list) {
					let newEle = {
						return_id: item.return_id,
						money: 0,
						checked: false,
						id: this.current_id,
					}
					if(item.return_info && typeof(item.return_info) == 'string') {
						let JSreturnInfo = JSON.parse(item.return_info)
						let index = JSreturnInfo.findIndex(v=>v.field_sign == '回款金额')
						if(index != -1 && JSreturnInfo[index]) {
							newEle.money = JSreturnInfo[index].content || 0
						}
					}
					this.tablelist.push(newEle)
					this.current_id += 1
				}
			
			},
			// 自定义事件，滚动条触底时触发 获取产品  
			loadMore() {
				if (this.selectobj.page < this.selectobj.last_page) {
					this.selectobj.page += 1
					this.getSelectList() 
				}
			},
		},
		directives: { // 在组件中接受一个 directives 的选项
			loadMore: {
				inserted(el, binding) {
					const dom = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap'); // 获取下拉框元素
					dom.addEventListener('scroll', function() { // 监听元素触底
						const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
						if (condition) {
							binding.value();
						}
					});
				},
			},
		},

		watch: {
			returnid(){
				if(this.returnid && typeof(this.returnid) == 'string'){
					this.getSelectList(this.returnid, true)
				}
			},
		},
		created() {
			if(this.returnid && typeof(this.returnid) == 'string'){
				this.getSelectList(this.returnid, true)
			}
			else {
				this.getSelectList()
			}
		},

	}
</script>

<style lang="scss" scoped>
	.delspan {

		cursor: pointer;
		font-size: 14px;
		font-weight: 400;
		color: rgba(43, 117, 235, 1);
		text-align: left;
		vertical-align: top;
	}

	.btn_box {
		margin-bottom: 20px;
	}

	.amount_box {
		width: 99%;
		margin: 0 auto;
		min-height: 39px;
		background: rgba(249, 249, 249, 1);
		padding-left: 65px;
		padding-right: 20px;
		.amount_item {
		
			font-size: 14px;
			font-weight: 550;
			color: rgba(56, 56, 56, 1);
			text-align: left;
			vertical-align: top;
		}
	}
</style>